import React from "react";
import { Modal } from "react-bootstrap";
import { CoinRentType } from "../../../api/API";
import "./UseTypeInfoModal.css";

interface UseTypeInfoModalProps {
  show: boolean;
  onHide: () => void;
  rentTypes: CoinRentType[];
  loading: boolean;
}

const UseTypeInfoModal: React.FC<UseTypeInfoModalProps> = ({
  show,
  onHide,
  rentTypes,
  loading
}) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    animation={false}
    aria-labelledby="use-type-info-title"
  >
    <Modal.Header closeButton>
      <Modal.Title id="use-type-info-title">Use types</Modal.Title>
    </Modal.Header>
    <Modal.Body className="use-type-info-body">
      {loading && <p>Loading use types…</p>}
      {!loading && rentTypes.length === 0 && (
        <p>No use types are configured for coins on this date.</p>
      )}
      {!loading && rentTypes.length > 0 && (
        <ul className="use-type-info-list">
          {rentTypes.map(rentType => (
            <li key={rentType.id}>
              <h5>{rentType.name}</h5>
              <p>{rentType.description?.trim() || "No additional description is available."}</p>
            </li>
          ))}
        </ul>
      )}
    </Modal.Body>
  </Modal>
);

export default UseTypeInfoModal;
